import { render, staticRenderFns } from "./IpAllocationManagement.vue?vue&type=template&id=169e2bd8&"
import script from "./IpAllocationManagement.vue?vue&type=script&lang=js&"
export * from "./IpAllocationManagement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports